import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.concat.js";
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { CefEvent, Platform } from "../../../EventTracker";
import { getStepName, getPageName } from "../../../EventTracker/utilities";
import { useIsMobile } from "../Common/useIsMobile";
import { useCefEventTracker } from "./useCefEventTracker";
import { useAppContext } from "../Providers";
import { studentOnboarding } from "../../controller/consts";
import { Routes } from "../Common/Constants";
function useCefNavigation() {
  var history = useHistory();
  var _useCefEventTracker = useCefEventTracker(),
    trackEvent = _useCefEventTracker.trackEvent;
  var _useAppContext = useAppContext(),
    onboardingMode = _useAppContext.onboardingMode;
  var isMobile = useIsMobile();
  var navigate = useCallback(function (route) {
    var from_step = getStepName(history.location.pathname);
    var pathName = history.location.pathname;
    history.push(route);
    var platform = isMobile ? Platform.Mobile : Platform.Desktop;
    var to_step = getStepName(route);
    trackEvent(CefEvent("Navigated to ".concat(to_step), platform, {
      from_step: from_step
    }));
    // for cef questions from within the onboarding flow
    if (onboardingMode && Object.values(Routes.Eligibility).includes(pathName)) {
      trackEvent({
        event: "".concat(studentOnboarding, " - CEF: Passed ").concat(getPageName(pathName)),
        group: studentOnboarding
      });
    }
  }, [isMobile, history, onboardingMode, trackEvent]);
  return navigate;
}
export default useCefNavigation;